import FormattedMessage from 'I18n/components/FormattedMessage';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { H5 } from 'foundations-components/transitional/components/H5';
import { PopoverHeader, PopoverBody } from 'foundations-components/transitional/components/Popover';
import GoVideoContainer from './GoVideoContainer';

// @ts-expect-error ts-migrate(2456) FIXME: Type alias 'Props' circularly references itself.
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// @ts-expect-error ts-migrate(7022) FIXME: 'GoVideoPopoverContent' implicitly has type 'any' ... Remove this comment to see the full error message
const GoVideoPopoverContent = ({
  isInServiceHub = false,
  onChange,
  onClose,
  showHeader,
  trackingHandlers,
  recipientEmail,
  isInlineVideo,
  showTitleCheckBox
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [showHeader && /*#__PURE__*/_jsxs(PopoverHeader, {
      children: [/*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "draftPlugins.goVideoModal.title"
        })
      }), /*#__PURE__*/_jsx(CloseButton, {
        color: "border-core-hover",
        size: "medium",
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(PopoverBody, {
      children: /*#__PURE__*/_jsx("div", {
        style: {
          height: 378
        },
        children: /*#__PURE__*/_jsx(GoVideoContainer, {
          isInServiceHub: isInServiceHub,
          onChange: onChange,
          onClose: onClose,
          trackingHandlers: trackingHandlers,
          recipientEmail: recipientEmail,
          isInlineVideo: isInlineVideo,
          showTitleCheckBox: showTitleCheckBox
        })
      })
    })]
  });
};
export default GoVideoPopoverContent;